/** 採購異動 UI 共用元件的單據別（純常數，不含 API 依賴，供 helper／測試引用）。 */
export const PURCHASE_AMENDMENT_KIND = {
  PURCHASE_ORDER: 'purchaseOrder',
  MISC_PURCHASE_ORDER: 'miscPurchaseOrder',
};
